<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Bank">
            <w-flex class="mt3">
                <div class="xs4">
                    <z-lookup
                        label="Bank"
                        name="bank"
                        :url="service_utiliti + 'lookup/bank'"
                        placeholder="Sila Pilih Bank"
                        :sort="false"
                        :cache="false"
                        v-model="cari.lkp_bank_id"
                    />
                </div>
                <div class="xs4">
                    <w-input
                        label="No Akaun"
                        name="no akaun"
                        placeholder="Sila Masukkan No Akaun"
                        :sort="false"
                        :cache="false"
                        v-model="cari.no_akaun"
                    />
                </div>
            </w-flex>

            <w-flex class="mt3">
                <div class="xs4">
                    <w-input
                        label="Cawangan"
                        name="cawangan"
                        placeholder="Sila Masukkan Cawangan"
                        :sort="false"
                        :cache="false"
                        v-model="cari.cawangan"
                    />
                </div>
            </w-flex>

            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1" @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>

            <w-dialog
                v-model="modal.show"
                :fullscreen="modal.fullscreen"
                :width="modal.width"
                :persistent="modal.persistent"
                :persistent-no-animation="modal.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Paparan Bank </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="modal.valid"
                        @validate="send"
                        @success="success"
                    >
                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Bank :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.bank }}
                                </div>
                            </div>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">No akaun :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.no_akaun }}
                                </div>
                            </div>
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Jenis Akaun :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.jenis_akaun_desc }}
                                </div>
                            </div>
                        </w-flex>

                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Cawangan :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.cawangan }}
                                </div>
                            </div>
                        </w-flex>
                        <w-tabs
                            :items="tabs"
                            :no-slider="false"
                            active-class="primary"
                        >
                            <template #item-content.1>
                                <table class="w-table">
                                    <thead>
                                        <tr>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                No
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Tindakan
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Pengguna
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Tarikh
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                dt, index
                                            ) in form.jejak_audit"
                                        >
                                            <td class="w-table__cell text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{
                                                    dt.tindakan_bank_keterangan
                                                }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{ dt.user_nama }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{ dt.tarikh }}
                                            </td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td
                                                class="w-table__cell text-left"
                                                colspan="5"
                                            ></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </w-tabs>
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="modal.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <template v-if="form.bank"> Kemaskini Bank </template>
                    <template v-else> Tambah Bank </template>
                </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submit"
                        @success="success"
                    >
                        <template></template>

                        <w-flex justify-space-between class="mb4">
                            <z-lookup
                                label="Bank*"
                                name="bank"
                                :url="service_utiliti + 'lookup/bank'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_bank_id"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="No Akaun*"
                                name="nama1"
                                v-model="form.no_akaun"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Cawangan*"
                                name="nama2"
                                v-model="form.cawangan"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-lookup
                                label="Jenis Akaun*"
                                :options="status1"
                                v-model="form.jenis_akaun"
                                :sort="false"
                                :cache="false"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <label>Status*</label>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <w-switch
                                class="mr6"
                                v-model="form.status"
                            ></w-switch>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >{{ form.saveButton }}</w-button
                    >
                </template>
            </w-dialog>

            <z-table
                ref="tbluser"
                title="Senarai Bank"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #button>
                    <template v-if="$zutil.can('Bank Tambah')">
                        <w-button
                            dark
                            class="indigo-dark2--bg ml1"
                            @click="newrecord()"
                        >
                            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                        </w-button>
                    </template>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" tile @click="show(item)">
                                    fal fa-eye
                                </w-icon>
                            </template>
                            Papar
                        </w-tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <template v-if="$zutil.can('Bank Kemaskini')">
                                    <w-icon v-on="on" tile @click="edit(item)">
                                        fal fa-pencil
                                    </w-icon>
                                </template>
                            </template>
                            Kemaskini
                        </w-tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" tile @click="destroy(item)">
                                    fal fa-trash
                                </w-icon>
                            </template>
                            Padam
                        </w-tooltip>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "bank",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "AKTIF",
                },
                {
                    value: 0,
                    label: "TIDAK AKTIF",
                },
            ],

            status1: [
                {
                    value: 1,
                    label: "TERIMAAN",
                },
            ],
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Utiliti", route: "/utiliti" },
                { label: "Bank Terimaan ", route: "/utiliti/bank" },
            ],

            tabs: [{ title: "Jejak Audit", content: "" }],
            cari: {
                lkp_bank_id: "",
                jabatan_id: "",
                no_akaun: "",
                cawangan: "",
            },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("utiliti.bank.index") +
                    "?lkp_bank_id=" +
                    this.cari.lkp_bank_id +
                    "&jabatan_id=" +
                    this.cari.jabatan_id +
                    "&no_akaun=" +
                    this.cari.no_akaun +
                    "&cawangan=" +
                    this.cari.cawangan,
                { preserveScroll: true }
            );
        },
        reset() {
            this.cari = {
                lkp_bank_id: "",
                jabatan_id: "",
                no_akaun: "",
                cawangan: "",
            };
            this.search();
        },

        show(idx) {
            this.form = idx;
            this.form.saveButton = "Kemaskini";
            this.modal.show = true;
        },
    },
    watch: {},
    mounted() {
        this.dialog.width = 500;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.lkp_bank_id == "undefined") {
            this.cari.lkp_bank_id = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        if (this.cari.no_akaun == "undefined") {
            this.cari.no_akaun = "";
        }
        if (this.cari.cawangan == "undefined") {
            this.cari.cawangan = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
